<div class="row" style="float: right; width: 500px;">
  <div class="form-group col-md-12" style="display: inline-flex; position: relative;">
    <form style="display: flex;position: absolute; right: 0px; top: -20px;">
      <div style="cursor: pointer; max-width: 100px; width: -webkit-fill-available;" *ngIf="esbusqueda"
        (click)="restoreTable()" class="text-danger">
        <span class="material-icons">restore</span> Reset Table
      </div>
      <input style="margin-right: 10px;  margin-left: 10px; padding: 22px;" type="text" placeholder="Search" class="form-control"
        id="campoBusquedaForm" [ngModelOptions]="{standalone: true}" #campoBusquedaForm="ngModel"
        [(ngModel)]="campoBusqueda">
<!--       <button style="margin-left: 10px;" (click)="search()" class="btn btn-md btn-info">
        Search
      </button> -->
      <button
      style="height: 44px; width: 120px;  "
      class="gts-btn-primary-outline"
      matRipple
      (click)="search()"
    >
      <span class="gts-btn-text">Search</span>
    </button>
    </form>
  </div>
</div>
<br><br>